'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/inherits");

var pull = require('pull-stream');

var debug = require('debug');

var PeerInfo = require('peer-info');

var PeerId = require('peer-id');

var EE = require('events').EventEmitter;

var once = require('once');

var utilsFactory = require('./utils');

var StreamHandler = require('./stream-handler');

var proto = require('../protocol').CircuitRelay;

var multiaddr = require('multiaddr');

var series = require('async/series');

var waterfall = require('async/waterfall');

var multicodec = require('./../multicodec');

var log = debug('libp2p:swarm:circuit:relay');
log.err = debug('libp2p:swarm:circuit:error:relay');

var Hop =
/*#__PURE__*/
function (_EE) {
  _inherits(Hop, _EE);

  /**
   * Construct a Circuit object
   *
   * This class will handle incoming circuit connections and
   * either start a relay or hand the relayed connection to
   * the swarm
   *
   * @param {Swarm} swarm
   * @param {Object} options
   */
  function Hop(swarm, options) {
    var _this;

    _classCallCheck(this, Hop);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Hop).call(this));
    _this.swarm = swarm;
    _this.peerInfo = _this.swarm._peerInfo;
    _this.utils = utilsFactory(swarm);
    _this.config = options || {
      active: false,
      enabled: false
    };
    _this.active = _this.config.active;
    return _this;
  }
  /**
   * Handle the relay message
   *
   * @param {CircuitRelay} message
   * @param {StreamHandler} sh
   * @returns {*}
   */


  _createClass(Hop, [{
    key: "handle",
    value: function handle(message, sh) {
      var _this2 = this;

      if (!this.config.enabled) {
        this.utils.writeResponse(sh, proto.Status.HOP_CANT_SPEAK_RELAY);
        return sh.close();
      } // check if message is `CAN_HOP`


      if (message.type === proto.Type.CAN_HOP) {
        this.utils.writeResponse(sh, proto.Status.SUCCESS);
        return sh.close();
      } // This is a relay request - validate and create a circuit


      var srcPeerId = PeerId.createFromBytes(message.dstPeer.id);

      if (srcPeerId.toB58String() === this.peerInfo.id.toB58String()) {
        this.utils.writeResponse(sh, proto.Status.HOP_CANT_RELAY_TO_SELF);
        return sh.close();
      }

      var dstPeerId = PeerId.createFromBytes(message.dstPeer.id).toB58String();

      if (!message.dstPeer.addrs.length) {
        // TODO: use encapsulate here
        var addr = multiaddr("/p2p-circuit/ipfs/".concat(dstPeerId)).buffer;
        message.dstPeer.addrs.push(addr);
      }

      var noPeer = function noPeer(err) {
        log.err(err);

        _this2.utils.writeResponse(sh, proto.Status.HOP_NO_CONN_TO_DST);

        return sh.close();
      };

      var isConnected = function isConnected(cb) {
        var dstPeer;

        try {
          dstPeer = _this2.swarm._peerBook.get(dstPeerId);

          if (!dstPeer.isConnected() && !_this2.active) {
            var err = new Error('No Connection to peer');
            noPeer(err);
            return cb(err);
          }
        } catch (err) {
          if (!_this2.active) {
            noPeer(err);
            return cb(err);
          }
        }

        cb();
      };

      series([function (cb) {
        return _this2.utils.validateAddrs(message, sh, proto.Type.HOP, cb);
      }, function (cb) {
        return isConnected(cb);
      }, function (cb) {
        return _this2._circuit(sh.rest(), message, cb);
      }], function (err) {
        if (err) {
          log.err(err);
          setImmediate(function () {
            return _this2.emit('circuit:error', err);
          });
        }

        setImmediate(function () {
          return _this2.emit('circuit:success');
        });
      });
    }
    /**
     * Connect to STOP
     *
     * @param {PeerInfo} peer
     * @param {StreamHandler} srcSh
     * @param {function} callback
     * @returns {function}
     */

  }, {
    key: "_connectToStop",
    value: function _connectToStop(peer, srcSh, callback) {
      var _this3 = this;

      this._dialPeer(peer, function (err, dstConn) {
        if (err) {
          _this3.utils.writeResponse(srcSh, proto.Status.HOP_CANT_DIAL_DST);

          log.err(err);
          return callback(err);
        }

        return _this3.utils.writeResponse(srcSh, proto.Status.SUCCESS, function (err) {
          if (err) {
            log.err(err);
            return callback(err);
          }

          return callback(null, dstConn);
        });
      });
    }
    /**
     * Negotiate STOP
     *
     * @param {StreamHandler} dstSh
     * @param {StreamHandler} srcSh
     * @param {CircuitRelay} message
     * @param {function} callback
     * @returns {function}
     */

  }, {
    key: "_negotiateStop",
    value: function _negotiateStop(dstSh, srcSh, message, callback) {
      var _this4 = this;

      var stopMsg = Object.assign({}, message, {
        type: proto.Type.STOP // change the message type

      });
      dstSh.write(proto.encode(stopMsg), function (err) {
        if (err) {
          _this4.utils.writeResponse(srcSh, proto.Status.HOP_CANT_OPEN_DST_STREAM);

          log.err(err);
          return callback(err);
        } // read response from STOP


        dstSh.read(function (err, msg) {
          if (err) {
            log.err(err);
            return callback(err);
          }

          var message = proto.decode(msg);

          if (message.code !== proto.Status.SUCCESS) {
            return callback(new Error("Unable to create circuit!"));
          }

          return callback(null, msg);
        });
      });
    }
    /**
     * Attempt to make a circuit from A <-> R <-> B where R is this relay
     *
     * @param {Connection} srcConn - the source connection
     * @param {CircuitRelay} message - the message with the src and dst entries
     * @param {Function} callback - callback to signal success or failure
     * @returns {void}
     * @private
     */

  }, {
    key: "_circuit",
    value: function _circuit(srcConn, message, callback) {
      var _this5 = this;

      var dstSh = null;
      var srcSh = new StreamHandler(srcConn);
      waterfall([function (cb) {
        return _this5._connectToStop(message.dstPeer, srcSh, cb);
      }, function (_dstConn, cb) {
        dstSh = new StreamHandler(_dstConn);

        _this5._negotiateStop(dstSh, srcConn, message, cb);
      }], function (err) {
        if (err) {
          // close/end the source stream if there was an error
          if (srcSh) {
            srcSh.close();
          }

          if (dstSh) {
            dstSh.close();
          }

          return callback(err);
        }

        var src = srcSh.rest();
        var dst = dstSh.rest(); // circuit the src and dst streams

        pull(src, dst, src);
        callback();
      });
    }
    /**
     * Dial the dest peer and create a circuit
     *
     * @param {Multiaddr} dstPeer
     * @param {Function} callback
     * @returns {Function|void}
     * @private
     */

  }, {
    key: "_dialPeer",
    value: function _dialPeer(dstPeer, callback) {
      var peerInfo = new PeerInfo(PeerId.createFromBytes(dstPeer.id));
      dstPeer.addrs.forEach(function (a) {
        return peerInfo.multiaddrs.add(a);
      });
      this.swarm.dial(peerInfo, multicodec.relay, once(function (err, conn) {
        if (err) {
          log.err(err);
          return callback(err);
        }

        callback(null, conn);
      }));
    }
  }]);

  return Hop;
}(EE);

module.exports = Hop;